// Colour mapping table for product colour names to colour values
const ColourMapping = {
  White: 'F1F1F1',
  Black: '1D1D1D',
  Gray: '808080',
  Brown: '96532f',
  Red: 'D12425',
  Green: '506538',
  Blue: '146375',
  Yellow: 'DDC105',
  Pink: 'D493A2',
  Orange: 'DE6F27',
  Purple: '410E61',
};

export default ColourMapping;
